<scaffold-dialog
  [showCloseButton]="showCloseButton"
  (close)="handleClick()"
  [title]="title"
  [fit]="fit"
  [fullHeight]="fullHeight"
  [size]="size"
>
  <div scaffoldDialogBody>
    <div class="date-modal-top-row">
      <label class="data-modal-label">
        <ng-container *ngIf="text; else defaulttext">{{ text }}</ng-container>
        <ng-template #defaulttext>
          {{
            useRange
              ? ("select_dates" | translation)
              : ("select_a_date" | translation)
          }}
        </ng-template>
      </label>
    </div>

    <ng-container *ngIf="useRange">
      <div class="date-modal-range-dates-container">
        <div class="date-modal-range-date-container">
          <div>
            <label class="data-modal-label">{{ "from" | translation }}</label>
          </div>

          <p-datepicker
            fluid
            appendTo="body"
            [iconDisplay]="'input'"
            [showIcon]="true"
            [(ngModel)]="fromDate"
            [placeholder]="'start_date' | translation"
            (onSelect)="updateFromDate($event)"
          />
        </div>
        <div class="date-modal-range-date-container">
          <div>
            <label class="data-modal-label">{{ "till" | translation }}</label>
          </div>
          <p-datepicker
            fluid
            appendTo="body"
            [iconDisplay]="'input'"
            [showIcon]="true"
            [(ngModel)]="tillDate"
            [placeholder]="'end_date' | translation"
            (onSelect)="updateTillDate($event)"
          />
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!useRange">
      <p-datepicker
        fluid
        appendTo="body"
        [iconDisplay]="'input'"
        [showIcon]="true"
        [(ngModel)]="date"
        [placeholder]="'select_date' | translation"
        (onSelect)="updateDate($event)"
      />
    </ng-container>
  </div>

  <div scaffoldDialogButtons>
    <app-button status="secondary" (click)="handleClick()">
      {{ declineMessage || "cancel" | translation }}
    </app-button>
    <app-button
      
      status="primary"
      cdkFocusInitial
      (click)="handleClick(true)"
    >
      {{ confirmMessage || "submit" | translation }}
    </app-button>
  </div>
</scaffold-dialog>
